import { RoomContext } from "App/context";
import { DraftContext } from "pages/Draft/context";
import { useContext } from "react";
import { DraftStep } from "types/Draft/type";
import { Role } from "types/Room/type";

export const isCaptainRole = (
  role?: Role | DraftStep["player"],
): role is "Player 1" | "Player 2" =>
  role === "Player 1" || role === "Player 2";

/*
  Le camp pour lequel le joueur local agit. En solo, il joue les deux camps : pendant la draft
  il agit pour celui dont c'est le tour (même règle que le serveur). Partout ailleurs, et hors
  solo, c'est son rôle.
*/
export const useActingRole = (): Role => {
  const { role, params } = useContext(RoomContext);
  const { currentStep } = useContext(DraftContext);
  const stepPlayer = currentStep?.player;
  if (params.solo && isCaptainRole(role) && isCaptainRole(stepPlayer))
    return stepPlayer;
  return role;
};
